import React from "react";

interface TextButtonProps {
  title: string;
  onPress: () => void;
  disabled?: boolean;
  className?: string;
}

export const TextButton: React.FC<TextButtonProps> = ({
  title,
  onPress,
  disabled = false,
  className = "",
}) => {
  return (
    <button
      type="button"
      onClick={onPress}
      disabled={disabled}
      className={`px-2.5 py-2.5 font-oswald text-[15px] font-normal text-white underline transition-opacity disabled:cursor-not-allowed disabled:opacity-50 ${className}`}
    >
      {title}
    </button>
  );
};
